import { render, staticRenderFns } from "./tkuanzs.vue?vue&type=template&id=7dc216fa&scoped=true"
import script from "./tkuanzs.vue?vue&type=script&lang=js"
export * from "./tkuanzs.vue?vue&type=script&lang=js"
import style0 from "./tkuanzs.vue?vue&type=style&index=0&id=7dc216fa&prod&lang=scss&scoped=true"
import style1 from "./tkuanzs.vue?vue&type=style&index=1&id=7dc216fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc216fa",
  null
  
)

export default component.exports